import planImportStore             from '@/TokamapEditor/planImport/planImportStore';
import type { PlanMatchCandidate } from '@models/map/dxfTypes';

export type PlanMatchOption = {
	field: string;
	label: string;
	matched: number;
	existing: number;
	recommended: boolean;
};

export function matchOptions(candidates: PlanMatchCandidate[], typeOfCategory: Map<string, string>): PlanMatchOption[] {
	const byField = new Map<string, PlanMatchOption & { existingByType: Map<string, number> }>();

	for (const candidate of candidates) {
		const type = typeOfCategory.get(candidate.category);
		if (!type) continue;

		const option = byField.get(candidate.field)
			?? { field: candidate.field, label: candidate.label, matched: 0, existing: 0, recommended: false, existingByType: new Map() };
		option.matched += candidate.matched;
		option.existingByType.set(type, Math.max(option.existingByType.get(type) ?? 0, candidate.existing));
		option.recommended ||= candidate.recommended;
		byField.set(candidate.field, option);
	}

	return [...byField.values()]
		.map(({ existingByType, ...option }) => {
			const existing = [...existingByType.values()].reduce((total, count) => total + count, 0);

			return { ...option, existing, matched: Math.min(option.matched, existing) };
		})
		.sort((a, b) => b.matched - a.matched);
}

export function readyPlaceTypes(): Map<string, string> {
	return new Map(planImportStore.effectiveCategories
		.filter(category => category.enabled && category.placeTypeUrn)
		.map(category => [category.key, category.placeTypeUrn]));
}
